import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Diagram = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.111 2.5H5.88879L5.88879 5.16667L10.111 5.16667L10.111 2.5ZM5.88879 1.5C5.33651 1.5 4.88879 1.94771 4.88879 2.5V5.16667C4.88879 5.71895 5.33651 6.16667 5.88879 6.16667H7.50009V8.00002H5.11121C4.28278 8.00002 3.61121 8.6716 3.61121 9.50002V10.8333H2C1.44772 10.8333 1 11.281 1 11.8333V14.5C1 15.0523 1.44771 15.5 2 15.5H6.22222C6.77451 15.5 7.22222 15.0523 7.22222 14.5V11.8333C7.22222 11.281 6.77451 10.8333 6.22222 10.8333H4.61121V9.50002C4.61121 9.22388 4.83506 9.00002 5.11121 9.00002H8.00009H8.50009V9H10.8889C11.165 9 11.3889 9.22386 11.3889 9.5V10.8333H9.77787C9.22559 10.8333 8.77787 11.281 8.77787 11.8333V14.5C8.77787 15.0523 9.22559 15.5 9.77787 15.5H14.0001C14.5524 15.5 15.0001 15.0523 15.0001 14.5V11.8333C15.0001 11.281 14.5524 10.8333 14.0001 10.8333H12.3889V9.5C12.3889 8.67157 11.7173 8 10.8889 8H8.50009V6.16667H10.111C10.6633 6.16667 11.111 5.71895 11.111 5.16667V2.5C11.111 1.94772 10.6633 1.5 10.111 1.5H5.88879ZM6.22222 11.8333H2L2 14.5H6.22222L6.22222 11.8333ZM9.77787 11.8333H14.0001L14.0001 14.5H9.77787L9.77787 11.8333Z"
        fill={color}
      />
    </svg>
  )
})

export default Diagram
